import { IRes } from "api/types";
import { apiInstance, spApiInstance } from "api/instance";

import { type GetUserInfoRes, type GetCountryCodesRes } from "./res";
import {
  type UpdateUserReq,
  type AddMissedItemReq,
  type AddQuickMessageReq,
  type GetBuildingDataWithGuidReq,
} from "./req";
import { ENDPOINTS, SP_NAMES } from "api/constants";

export const updateUserApi = (body: UpdateUserReq) => {
  return spApiInstance<void>(SP_NAMES.UpdateUser, body);
};
export const addMissedItemApi = (body: AddMissedItemReq) => {
  return spApiInstance<void>(SP_NAMES.AddMissedItem, body);
};
export const addQuickMessageApi = (body: AddQuickMessageReq) => {
  return spApiInstance<void>(SP_NAMES.AddQuickMessage, body);
};

export const getCountryCodes = (): Promise<GetCountryCodesRes[]> => {
  return apiInstance
    .post<IRes<GetCountryCodesRes[]>>(ENDPOINTS.COUNTRY_SELECT, {})
    .then((response) => response.data)
    .then(
      (response) => {
        if (response.successful) {
          return Promise.resolve(response.result);
        }
        throw new Error(response.resultMessage);
      },
      (error) => {
        const errorBody = error?.response?.data;
        // as ErrorMessage;
        // return Promise.reject(errorTranslator(errorBody));
        return Promise.reject(errorBody);
      }
    )
    .catch((error) => {
      return Promise.reject(error);
    });
};

export {
  GetUserInfoRes,
  AddMissedItemReq,
  GetCountryCodesRes,
  AddQuickMessageReq,
  GetBuildingDataWithGuidReq,
};
